import { useDialog } from "@platform/store";
import VideoMeetingControlsEndMeeting from "./VideoMeetingControlsEndMeeting";

export function VideoMeetingControlsEndMeetingContainer() {
  const { openDialog } = useDialog();

  return <VideoMeetingControlsEndMeeting onClick={() => openDialog("endMeeting")} />;
}

export default VideoMeetingControlsEndMeetingContainer;
